export default __webpack_public_path__ + "static/media/img_twilight_11111.1c42cf4f.png";